// extracted by mini-css-extract-plugin
export var base = "_4l-0";
export var updateBanner = "_4l-1";